import { createAsyncAction } from 'typesafe-actions'
import { ContactState } from '../../types'
import { Failure, Request, Success } from './types'

export const fetchContactsByCompanyAction = createAsyncAction(
  '@contact/FETCH_CONTACTS_BY_COMPANY_REQUEST',
  '@contact/FETCH_CONTACTS_BY_COMPANY_SUCCESS',
  '@contact/FETCH_CONTACTS_BY_COMPANY_FAILURE'
)<Request, Success, Failure>()

const request = (state: ContactState): ContactState => ({
  ...state,
  isLoadingFetchContactsByCompany: true
})

const success = (
  state: ContactState,
  action: ReturnType<typeof fetchContactsByCompanyAction.success>
): ContactState => {
  return {
    ...state,
    contacts: action.payload.contacts,
    isSuccessFetchContactsByCompany: true,
    isLoadingFetchContactsByCompany: false,
    isErrorOnFetchContactsByCompany: false
  }
}

const failure = (
  state: ContactState,
  action: ReturnType<typeof fetchContactsByCompanyAction.failure>
): ContactState => {
  return {
    ...state,
    isLoadingFetchContactsByCompany: false,
    isErrorOnFetchContactsByCompany: true
  }
}

export const fetchContactsByCompanyHandle = { asyncAction: fetchContactsByCompanyAction, request, success, failure }
